
// since i18next update "default" has to be used.
var i18next         = (require('i18next') || {}).default;
var resBundle       = require('i18next-resource-store-loader!translations');
var i18nextOptions  = {
	defaultNS: 'common',
	lng: 'de-at',
	lngs: ['de-at'],
	fallbackLng: ['de-at'],
	lowerCaseLng: true,
	resources: resBundle,
	debug: true
};

module.exports = {
	init: function(options){
		if(!i18next) return null;

		for(var key in options){
			i18nextOptions[key] = options[key];
		}
		return i18next.init(i18nextOptions).then(function(){
			return Promise.resolve(i18next);
		});
	}
};
